export enum UserAccountStatus {
    EmailVerificationRequired = 1,
    ProfileDetailsRequired = 2,
    Active = 3,
    InActive = 4,
    New = 5,
    AccountApprovalRequired = 6
}